export const UPDATE_SAVED_PART_NUMBER = 'UPDATE_SAVEDPARTNUMBER';

export function updateSavedPartNumber(savedPartNumber, totalRecords, PageNumber) {
    return {
        type: UPDATE_SAVED_PART_NUMBER,
        savedPartNumber,
        totalRecords,
        PageNumber
    }
}